import styled, { css } from 'styled-components';
import { mobile_xl } from '../../global/mediaQueryMixin';

const Printscreen = styled.div`
  width: fit-content;
  border-radius: 6px;
  border: 0.5px solid var(--border-primary);
  background-color: var(--background-tertiary);
  margin-top: 12px;
  overflow: hidden;
  :first-child {
    margin-top: 10px !important;
  }
  .ant-image .ant-image-img {
    border-right: 0;
    border-left: 0;
    border-top-right-radius: 0px !important;
  }

  .ant-image .ant-image-mask {
    border-radius: 0 0 6px 6px !important;
  }

  .ant-image .ant-image-mask {
    background-color: var(--background-thumb-overlay);
    border-radius: 6px;
  }
  .ant-image {
    margin: 0;
  }
`;

const CopyIcon = styled.div`
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    background-color: var(--neutral-secondary);
    .svgIcon {
      path {
        stroke: var(--text-primary);
      }
    }
  }
  .svgIcon {
    path {
      stroke: var(--text-secondary);
    }
  }
`;

const ActionDiv = styled.div`
  display: flex;
  .figma-button {
    order: 2;
    border-radius: 6px;
  }
  .three-dot-icon {
    display: flex;
    gap: 12px;
    order: 3;
  }
  .active {
    border-radius: 6px;
    background: var(--neutral-secondary);
  }
  ${mobile_xl(css`
    button {
      margin-left: 30px;
    }
  `)}
`;

export { Printscreen, CopyIcon, ActionDiv };
